import * as React from 'react'
import { Action, async, IOWidget, route, any, Widget, nothing, Pair, onlyIf, loadingAsyncState } from 'widgets-for-react'
import { AvailableLanguages, fromJSX } from '../../../../utils'
import { CustomRouteParams } from '../../../cms/router/type.gen'
import { emptyAppState, PublicSiteState } from '../../../public_site.main.mod'
import { CustomPage, CustomPagesState, PublicSiteCustomRoutes } from '../types.mod'
import { makeTransition, renderTransition } from './Fc150Years.utils'
import { Entity } from "ts-lenses"
import { notfound_page } from '../../templates/error_page.mod'
import { page } from '../../templates/page.mod'
import { PublicSite_CustomPageData } from '../../application.mod'
import { Block } from '../../../wordpress/types_and_parser/standard_blocks.gen'
import { CustomBlock } from '../../../wordpress/types_and_parser/custom_blocks.mod'
import { Page } from '../../../cms/page/types.gen'
import { WordPress } from '../../../wordpress/wordpress_api'
import { Map } from 'immutable'
import { homeWidget } from './widgets/HomeWidget'
import { storiesOverviewWidget } from './widgets/StoriesOverviewWidget'
import { storyDetailWidget } from './widgets/StoryDetailWidget'
import { transitionWidget } from './widgets/TransitionWidget'
import { get_pages_by_category, get_stories_overview } from './Fc150Years.api'
import { SimplePage } from './Fc150Years.types'



export const Fc150YearsMainPage: CustomPage<CustomPagesState['Fc150YearsMainPage']> = ({
  widget: r => fc150Widget()(r),

  route: route<{ overview_page_title?: string, story_title?: string, lang?: AvailableLanguages, taxonomy?: number }, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>('/:lang(en|nl|de)?/:overview_page_title?/:story_title?/',
    r => ({
      kind: 'Fc150YearsMainPage',
      overview_page_title: r.overview_page_title,
      story_title: r.story_title,
      lang: r.lang ? r.lang : 'en',
      taxonomy: r.taxonomy && !isNaN(r.taxonomy) ? Number(r.taxonomy) : undefined
    })),

  getState: (s: PublicSiteState) => s.Fc150YearsMainPage,

  setState: (s: PublicSiteState, ss: CustomPagesState['Fc150YearsMainPage']) => ({ ...s, Fc150YearsMainPage: ss }),

  updateStateBasesOnRoute: makeTransition
})


let fc150Widget = function (): IOWidget<Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPagesState["Fc150YearsMainPage"]>, Action<CustomPagesState["Fc150YearsMainPage"]>> {
  return r => {
    let s0 = r.snd


    return any<Action<CustomPagesState["Fc150YearsMainPage"]>>()([

      // When the loaders are loaded set the transition state to about to go down. Main loader to get the page content. This is always needed on every page.
      async<Page<CustomBlock, Block, PublicSite_CustomPageData>>()(s0.state.page.page).map(a => s => {
        let newPage = a(s.state.page.page)
        return Entity(s)
          .setIn('state', state => state.setIn('page', page0 => page0.set('page', _ => newPage)))
          .setIn('transition', t => t.set('animationState', animation => newPage.kind == 'loaded' || newPage.kind == 'failed' ? 'about-to-move-down' : animation))
          .set('current_page', current => newPage.kind == 'failed' ? '404' : current)
          .commit()
      }),

      onlyIf( // Loader for all taxonomies only used in an overview page. This async triggers the loader to get all the pages. The one below.
        (s0.current_page == 'transition-page' && ['stories-overview-page', 'story-detail-page'].includes(s0.transition.to.current_page) && !s0.transition.to.storiesOverviewState.isAbout),
        async<Map<number, WordPress.TaxonomyResponse>>()(s0.taxonomiesLoader).map(a => s => {
          let taxonomies = a(s.taxonomiesLoader)
          return Entity(s)
            .set('taxonomiesLoader', _ => taxonomies)
            .set('pagesloader', pagesLoader => pagesLoader.kind == 'unloaded' ? loadingAsyncState(() => get_pages_by_category(r.fst.kind == 'Fc150YearsMainPage' ? r.fst.lang : 'en', taxonomies.kind == 'loaded' ? taxonomies.value.toIndexedSeq().toArray().map(t => t.id) : [])) : pagesLoader)
            .commit()
        }),
      ),

      onlyIf( // Loader to get a list of pages, used in footer of an overview page
        (s0.current_page == 'transition-page' && ['stories-overview-page', 'story-detail-page'].includes(s0.transition.to.current_page) && !s0.transition.to.storiesOverviewState.isAbout),
        async<(WordPress.PageResponse & WordPress.EmbedData)[]>()(s0.pagesloader).map(a => s => Entity(s).set('pagesloader', pagesLoader => a(pagesLoader)).commit())
      ),

      any<Action<CustomPagesState['Fc150YearsMainPage']>>()(
        s0.storiesLoader.map<Widget<Action<CustomPagesState['Fc150YearsMainPage']>>>((loader, i) =>
          async<SimplePage<WordPress.StoryResponse[]>>()(loader).map(a => s => Entity(s)
            .set('storiesLoader', storiesLoader => {
              let newLoader = a(loader)
              if (newLoader.kind == 'loaded' && newLoader.value.total_pages != newLoader.value.page) {
                let entity = newLoader.value
                let nextLoader = loadingAsyncState(() => get_stories_overview(s0.lang, entity.taxonomy, entity.page + 1))
                return storiesLoader.set(i, newLoader).set(i + 1, nextLoader)
              }
              return storiesLoader.set(i, newLoader)
            })
            .commit())
        ).toArray()
      ),

      fromJSX((setState: (_: Action<CustomPagesState['Fc150YearsMainPage']>) => void) => {
        let current_page: Widget<CustomPagesState["Fc150YearsMainPage"]> = nothing()
        let transition_animation: Widget<Action<CustomPagesState["Fc150YearsMainPage"]>> = nothing()


        if (s0.current_page == "homepage") {
          current_page = homeWidget(r)(s0).map(a => a(s0))
          prev_widget = current_page
        }
        else if (s0.current_page == "stories-overview-page") {
          current_page = storiesOverviewWidget(r)(s0).map(a => a(s0))
          prev_widget = current_page
        }
        else if (s0.current_page == "story-detail-page") {
          current_page = storyDetailWidget(r)(s0).map(a => a(s0))
          prev_widget = current_page
        }
        else if (s0.current_page == "404") {
          let initPublicSiteState = emptyAppState(page)
          initPublicSiteState = ({ ...initPublicSiteState, Fc150YearsMainPage: s0 })
          current_page = notfound_page(initPublicSiteState)
        }
        else if (s0.current_page == "transition-page") {
          transition_animation = transitionWidget(r)(s0)
          if (s0.transition.animationState == "wave-moving-up" || s0.transition.animationState == "about-to-move-up") {
            current_page = prev_widget// s0.transition.from.v.kind == 'r' ? renderTransition(r, s0.transition.from.v.v, s0).map(a => a(s0)) : nothing()
          }
          else {
            current_page = renderTransition(r, s0.transition.to, s0).map(a => a(s0))
          }
        }

        return (
          <div className="faux-main">
            <div key="currentpage">
              {current_page.run(s => setState(_ => s))}
            </div>
            <div key="transition_page">
              {transition_animation.run(a => setState(_ => a(s0)))}
            </div>
          </div>
        )
      })
    ])
  }
}


let prev_widget: Widget<CustomPagesState["Fc150YearsMainPage"]> = nothing()
